import type { Theme, Components } from '@mui/material/styles';

import { varAlpha } from 'minimal-shared/utils';

// ----------------------------------------------------------------------

const MuiLink: Components<Theme>['MuiLink'] = {
  // ▼▼▼▼▼▼▼▼ ⚙️ PROPS ▼▼▼▼▼▼▼▼
  defaultProps: {
    underline: 'hover',
  },
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: ({ theme }) => ({
      textUnderlineOffset: '0.22em',
      textDecorationThickness: '0.08em',
      textDecorationColor: varAlpha('currentColor', 0.24),
      transition: theme.transitions.create(['color', 'text-decoration-color'], {
        duration: theme.transitions.duration.shorter,
      }),
      '&:hover': {
        textDecorationColor: 'currentColor',
      },
      '&:focus-visible': {
        borderRadius: 6,
        outline: `3px solid ${varAlpha(theme.vars.palette.primary.mainChannel, 0.16)}`,
        outlineOffset: 2,
      },
    }),
  },
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const link: Components<Theme> = {
  MuiLink,
};
